import {
  CrmOpportunity,
  CrmPipelineStage,
  FunnelStage,
  OpportunityStatus
} from '../types';

export interface CrmPipelineStageConfig {
  stage: CrmPipelineStage;
  label: string;
  description: string;
  color: string;
}

export const CRM_PIPELINE_STAGES: CrmPipelineStageConfig[] = [
  { stage: 'lead', label: 'Prospecto', description: 'Contacto nuevo por revisar', color: '#64748b' },
  { stage: 'contacted', label: 'Contactado', description: 'Primera conversación iniciada', color: '#64748b' },
  { stage: 'qualified', label: 'Calificado', description: 'Necesidad y encaje confirmados', color: '#0f766e' },
  { stage: 'proposal', label: 'Propuesta', description: 'Oferta comercial enviada', color: '#0f766e' },
  { stage: 'negotiation', label: 'Negociación', description: 'Condiciones en definición', color: '#0f766e' },
  { stage: 'won', label: 'Ganado', description: 'Venta confirmada', color: '#10b981' },
  { stage: 'lost', label: 'Perdido', description: 'Oportunidad descartada', color: '#ef4444' }
];

export const CRM_PIPELINE_STAGE_LABELS = Object.fromEntries(
  CRM_PIPELINE_STAGES.map(item => [item.stage, item.label])
) as Record<CrmPipelineStage, string>;

const LEGACY_FUNNEL_TO_CRM_STAGE: Record<FunnelStage, CrmPipelineStage> = {
  personal: 'lead',
  education: 'lead',
  offer: 'qualified',
  attraction: 'contacted',
  registration: 'proposal',
  nurturing: 'negotiation',
  attendance: 'qualified',
  delivery: 'negotiation',
  retention: 'proposal'
};

export const getCrmPipelineStage = (
  opportunity: Pick<CrmOpportunity, 'crmStage' | 'stage' | 'status'>
): CrmPipelineStage => {
  if (opportunity.status === 'won') return 'won';
  if (opportunity.status === 'lost') return 'lost';
  return opportunity.crmStage || LEGACY_FUNNEL_TO_CRM_STAGE[opportunity.stage] || 'lead';
};

export const getOpportunityStatusForCrmStage = (stage: CrmPipelineStage): OpportunityStatus => {
  if (stage === 'won') return 'won';
  if (stage === 'lost') return 'lost';
  return 'open';
};

export const getCrmStageForStatus = (
  status: OpportunityStatus,
  currentStage: CrmPipelineStage
): CrmPipelineStage => {
  if (status === 'won') return 'won';
  if (status === 'lost') return 'lost';
  return currentStage === 'won' || currentStage === 'lost' ? 'qualified' : currentStage;
};

export const getCrmPipelineStageConfig = (stage: CrmPipelineStage) => (
  CRM_PIPELINE_STAGES.find(item => item.stage === stage) || CRM_PIPELINE_STAGES[0]
);
